import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { genderOptions } from './schema';

export function GenderInput({ isEditable }: { isEditable?: boolean }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="gender"
      render={({ field: { value, onChange } }) => (
        <FormSelect
          disabled={!isEditable}
          value={value}
          getOptionLabel={(option) => option.name}
          onChange={onChange}
          options={genderOptions}
          label="Gender"
        />
      )}
    />
  );
}
